/**
 * Tradução da forma crua da API para o domínio pt-BR da tela de
 * parametrização (`TP-051`, T10/T11) — mesma disciplina de
 * `features/contratos/revisao/api/mapeadores.ts`.
 */

import {
  ehOrigemConhecida,
  ehSituacaoConhecida,
  type LinhaDaComparacao,
  ehTipoDeDivergenciaConhecido,
  type Divergencia,
  type DivergenciaApi,
  type ItemDaFilaDePara,
  type ItemDaFilaDeParaApi,
  type PropostaDePara,
  type PropostaDeParaApi,
  type Reconciliacao,
  type ReconciliacaoApi,
} from './tipos';

export function mapearDivergencia(bruto: DivergenciaApi): Divergencia {
  return {
    tipo: ehTipoDeDivergenciaConhecido(bruto.tipo) ? bruto.tipo : null,
    tipoBruto: bruto.tipo,
    codigo: bruto.codigo,
    descricao: bruto.descricao,
    detalhe: bruto.detalhe,
  };
}

export function mapearPropostaDePara(bruto: PropostaDeParaApi): PropostaDePara {
  return { codigoIw: bruto.codigoIw, itemContratualId: bruto.itemContratualId, descricao: bruto.descricao };
}

export function mapearReconciliacao(bruto: ReconciliacaoApi): Reconciliacao {
  return {
    avaliacaoId: bruto.avaliacaoId,
    cobertura: bruto.cobertura,
    divergencias: (bruto.divergencias ?? []).map(mapearDivergencia),
    propostas: (bruto.propostas ?? []).map(mapearPropostaDePara),
    criadoEm: bruto.criadoEm,
    // Situação desconhecida (API mais nova que o front) fica de fora, em vez de virar linha sem rótulo.
    linhas: (bruto.linhas ?? []).flatMap((l): LinhaDaComparacao[] =>
      ehSituacaoConhecida(l.situacao) ? [{ ...l, situacao: l.situacao }] : [],
    ),
  };
}

export function mapearItemDaFilaDePara(bruto: ItemDaFilaDeParaApi): ItemDaFilaDePara {
  return {
    codigoIw: bruto.codigoIw,
    itemContratualIdSugerido: bruto.itemContratualIdSugerido,
    descricao: bruto.descricao,
    origem: ehOrigemConhecida(bruto.origem) ? bruto.origem : null,
    origemBruta: bruto.origem,
    vezesSemCobertura: bruto.vezesSemCobertura,
  };
}
